import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';

export interface OrderItem {
  description: string;
  quantity: number;
  unitPrice: number;
  total: number;
}

export interface InvoiceData {
  invoiceNumber: string;
  date: Date;
  customerName: string;
  customerAddress: string;
  items: OrderItem[];
  subtotal: number;
  tax: number;
  total: number;
}

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  constructor() {}

  generateInvoice(data: InvoiceData): void {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;

    // Add company logo and info
    doc.setFontSize(20);
    doc.text('COMPANY NAME', 20, 20);
    doc.setFontSize(10);
    doc.text('123 Business Street', 20, 30);
    doc.text('City, State 12345', 20, 35);
    doc.text('Phone: (123) 456-7890', 20, 40);

    // Add invoice details
    doc.setFontSize(16);
    doc.text('INVOICE', pageWidth - 20, 20, { align: 'right' });
    doc.setFontSize(10);
    doc.text(`Invoice Number: ${data.invoiceNumber}`, pageWidth - 20, 30, { align: 'right' });
    doc.text(`Date: ${data.date.toLocaleDateString()}`, pageWidth - 20, 35, { align: 'right' });

    // Add customer info
    doc.setFontSize(12);
    doc.text('Bill To:', 20, 55);
    doc.setFontSize(10);
    doc.text(data.customerName, 20, 62);
    doc.text(data.customerAddress, 20, 67);

    // Add items table
    const tableColumn = ['Description', 'Quantity', 'Unit Price', 'Total'];
    const tableRows = data.items.map(item => [
      item.description,
      item.quantity.toString(),
      `$${item.unitPrice.toFixed(2)}`,
      `$${item.total.toFixed(2)}`
    ]);
    
    autoTable(doc, {
      startY: 80,
      head: [tableColumn],
      body: tableRows,
      theme: 'grid',
      headStyles: { fillColor: [66, 66, 66] }
    });
    
    // Add totals
    const finalY = (doc as any).lastAutoTable.finalY || 150;
    doc.text(`Subtotal: $${data.subtotal.toFixed(2)}`, pageWidth - 20, finalY + 10, { align: 'right' });
    doc.text(`Tax: $${data.tax.toFixed(2)}`, pageWidth - 20, finalY + 17, { align: 'right' });
    doc.setFontSize(12);
    doc.text(`Total: $${data.total.toFixed(2)}`, pageWidth - 20, finalY + 25, { align: 'right' });

    // Save the PDF
    doc.save(`invoice-${data.invoiceNumber}.pdf`);
  }
}